import styled from 'styled-components';

export const Dot = styled.div`
  position: fixed;
  bottom: 16px;
  left: 16px;
  z-index: 99999;
  pointer-events: auto;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  cursor: pointer;
  transition: background 0.2s, transform 0.2s;
  &:hover {
    background: rgba(255, 255, 255, 0.7);
    transform: scale(1.4);
  }
`;

export const Wrapper = styled.div`
  position: fixed;
  bottom: 16px;
  left: 16px;
  z-index: 99999;
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: rgba(0, 0, 0, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  padding: 8px 10px;
  backdrop-filter: blur(8px);
  font-family: monospace;
  user-select: none;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const Label = styled.div`
  font-size: 10px;
  letter-spacing: 1px;
  color: #aaa;
`;

export const ToggleButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #666;
  font-size: 10px;
  line-height: 1;
  display: flex;
  align-items: center;
  &:hover {
    color: #aaa;
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 6px;
`;

export const StatusText = styled.div`
  font-size: 10px;
  font-family: monospace;
  color: #666;
`;
